import { initReactI18next } from 'react-i18next';
import i18next from 'i18next';
import LOCALE from '@app/configs/locale';
import defineLocale from './defineLocale';
import loadTranslations from './loadTranslations';
const initTranslations = () => {
    const locale = defineLocale();
    i18next
        .use({
        type: 'backend',
        init: () => null,
        read: loadTranslations,
    })
        .use(initReactI18next)
        .init({
        lng: locale,
        debug: false,
        fallbackLng: LOCALE.DEFAULT_LOCALE,
        ns: ['loans-frontend'],
        defaultNS: 'loans-frontend',
        keySeparator: '',
        interpolation: {
            escapeValue: false,
        },
    });
    i18next.language = locale;
    return i18next;
};
export default initTranslations;
